import { ICellRendererParams } from "ag-grid-community";
import React from "react";
import { useImmer } from "use-immer";

import { IgTab, IgTabPanel, IgTabs } from "@intelligems/ig-theme";
import { AgencyDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { useGetFullAgencyById } from "@src/api/agencies/get-full-agency-by-id";
import { SkeletonGroup } from "@src/components/Utils/SkeletonGroup";
import { OrganizationsTab } from "@src/features/admin/pages/agencies/components/Expansions/AgenciesPanel/OrganizationsTab/OrganizationsTab";

import { CustomersTab } from "./CustomersTab/CustomersTab";
import { SubscriptionsTab } from "./SubscriptionsTab/SubscriptionsTab";

export const AgenciesPanel = (params: ICellRendererParams<AgencyDto>) => {
  const agency = useGetFullAgencyById(params.data!.id);
  const [tabIndex, setTabIndex] = useImmer<number>(0);

  if (!params.data) {
    return null;
  }

  return (
    <Grid
      container
      direction={"column"}
      rowSpacing={2}
      sx={{
        paddingTop: "0px",
        paddingLeft: "20px",
        paddingRight: "20px",
        paddingBottom: "5px",
      }}
    >
      <Grid item>
        <IgTabs
          underline={true}
          value={tabIndex}
          onChange={(e, value: number) => {
            setTabIndex(value);
          }}
        >
          <IgTab label="Subscriptions" />
          <IgTab label="Organizations" />
          <IgTab label="Stripe Customers" />
        </IgTabs>
        {agency.isSuccess ? (
          <Grid item>
            <IgTabPanel index={0} value={tabIndex}>
              <SubscriptionsTab agency={agency.data.agency} />
            </IgTabPanel>
            <IgTabPanel index={1} value={tabIndex}>
              <OrganizationsTab agency={agency.data.agency} />
            </IgTabPanel>
            <IgTabPanel index={2} value={tabIndex}>
              <CustomersTab agency={agency.data.agency} />
            </IgTabPanel>
          </Grid>
        ) : (
          <Grid item mt={2}>
            <SkeletonGroup lines={3} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
